/**
 * Created by Mark on 18/04/2017.
 */


import React from 'react';
import { FormattedMessage } from 'react-intl';
import { HelpBlock ,FormControl  , FormGroup ,ControlLabel , Collapse , Nav , NavItem , ButtonToolbar , ButtonGroup , Pagination , Checkbox , Table , Button, Row, Col, Clearfix } from 'react-bootstrap';
import FGFormGroup from '../../inputs/fg-input.js';
import autosize from 'autosize';
import ClassService from '../../../services/classes-service.js';
import LanguageSelector from '../../inputs/language-selector.js';
import Toggle from '../../inputs/input.toggle.component.js';
import StudentsService from '../../../services/student-services.js';
import StudentsStore from '../../../store/student-store.js';
import TableSearch from '../../tables/table.search.component.js';
import Student from '../../../classes/student.js';
import fuzzysearch from 'fuzzysearch';
import InternationalizationStore from '../../../store/internationalization-store.js';

class ReviewStudents extends React.Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.studentNames = [];
        this.state = {
            students:[],
            activeList:[],
            limit:11,
            index:0,
            tabIndex:0,
            studentsToAdd:this.props.data.addStudents || [],
            moveFrom:this.props.data.moveStudents || {},
            newStudnts:[],
            search:false,
            searchResults:[],
        };

        this.handleSelect    = this.handleSelect.bind(this);
        this.handelTabSelect = this.handelTabSelect.bind(this);
        this.addStudent      = this.addStudent.bind(this);



    }

    setSubmitProps(newStudents , moveStudents , addStudents){
        this.props.data.newStudents  = newStudents.map(function(student){return student.get('name') });
        this.props.data.moveStudents = Object.keys(moveStudents).map(function(k){ return moveStudents[k]});


        this.props.data.addStudents  = addStudents;



    }

    setSumbitPropsFromState(){
        this.setSubmitProps(this.state.newStudnts , this.state.moveFrom ,  this.state.studentsToAdd);
    }

    getActionIcon(action){

        switch(action){
            case"new":  return <i className="zmdi zmdi-plus-circle-o"></i>; break;
            case"move": return <i className="zmdi zmdi-square-right"></i>; break;
            case"add":  return <i className="zmdi zmdi-plus-circle-o-duplicate"></i>; break;
        }
    }

    convertUserInputToStudents(studentNames){
        var students= [];

        for(var idx = 0 ; idx < studentNames.length; idx++ ){
            var student = (new Student(idx + '-' + 'student' , studentNames[idx] , 'XXXXXXXXX' , 'XXXXXXXX' ,  [{uid:0 , name:this.props.data.name || '.....'}] ));
            student.action = "new";
            students.push(student);
        }

        return students;
    }

    isStudentInOtherList(uid){

        if(this.state.studentsToAdd.indexOf(uid) > -1)    return true;
        if(this.state.moveFrom[uid]) return true;

        return false;
    }

    componentDidMount() {
        this.setSubmitProps(this.convertUserInputToStudents(this.props.data.students || []) , this.props.data.moveStudents || {} , this.props.data.addStudents || []);
        StudentsService.getAll();
    }

    componentWillMount(){
        StudentsStore.on("CHANGE" , () => {
            this.setState({
                students:StudentsStore.allStudents,
                loading:true
            });
        });
    }

    handelRemove(action , studentIndex){

        var newStudentList  = this.state.newStudnts;
        var moveStudentList = this.state.moveFrom;
        var addStudentList  = this.state.studentsToAdd;


        console.log(action);
        switch(action){
            case "new":

                var newList = [];
                for(var idx = 0; idx < newStudentList.length; idx++){
                    if(newStudentList[idx].uid != studentIndex) newList.push(newStudentList[idx]);
                }

                newStudentList = newList;

                break;
            case "move":
                delete moveStudentList[studentIndex]
            break;
            case "add":

                if(addStudentList.indexOf(studentIndex) > -1){
                    addStudentList.splice(addStudentList.indexOf(studentIndex), 1);
                }

                break;
        }


        this.setState({newStudnts:newStudentList , moveFrom:moveStudentList , studentsToAdd:addStudentList});

    }

    getPage(students){

        if(this.state.tabIndex == 0)
        {
            var students  = students.filter(function(student){
                return !this.isStudentInOtherList(student.getID())
            }.bind(this));
        }

        var rowLimit  = parseInt(this.state.limit);
        return students.slice(this.state.index*rowLimit, (this.state.index*rowLimit) + rowLimit);
    }


    getStudentOptions(studentID , classID , classNumber , optionKey , action){

        optionKey = this.state.tabIndex == 0 ? optionKey : "option-3";
        let moveButton    = <button className="btn btn-block btn-primary" onClick={this.moveStudent.bind(this , studentID , classID)}><FormattedMessage id={ 'ui-00' } defaultMessage={ 'Överför till annan grupp' }/></button>;
        let addButton     = <button className="btn btn-block btn-primary" onClick={this.addStudent.bind(this , studentID)}><FormattedMessage id={ 'ui-00' } defaultMessage={ 'Kopiera elev till denna grupp' }/></button>;
        let remove        = <button className="btn btn-block btn-primary" onClick={this.handelRemove.bind(this , action , studentID)}><FormattedMessage id={ 'ui-350' } defaultMessage={ 'Remove' }/></button>;

        switch(optionKey)
        {
            case "option-1" : return [<td className="p-5">{moveButton}</td> , <td className="p-5" rowSpan={classNumber || 1}>{addButton}</td> ];
            case "option-2" : return [<td className="p-5">{moveButton}</td> ];
            case "option-3" : return [<td className="p-5">{remove}</td> ];
        }

    }


    handleSelect(page) {
        this.setState({index:page-1})
    }
    handelTabSelect(page) {
        this.search.value = "";
        this.setState({tabIndex:page , index:0 , search:false , searchResults:[]})
    }


    addStudent(student_uid){
        var addList = this.state.studentsToAdd;
        if(addList.indexOf(student_uid) > -1) return;

        addList.push(student_uid);
        this.setState({studentsToAdd:addList});
    }

    moveStudent(student_uid , classID){
        var moveList = this.state.moveFrom;
        if(moveList[student_uid]) moveList[student_uid].classes.push(classID);
        else moveList[student_uid] = {uid:student_uid , classes:[classID]};

        this.setState({moveFrom:moveList});
    }

    getAlUnassignedStudentsLength(){
        return this.state.students.length - this.state.moveFrom.length - this.state.studentsToAdd.length;
    }

    renderTableBody(students){

        var students = this.getPage(students);
        if(students.length == 0) return;
        var dom = [];


        for(var idx = 0; idx < students.length; idx++)
        {
           // if(this.isStudentInOtherList(students[idx].getID())) continue;

            var student  = students[idx];
            var classes = student.get('classes');
            var firstClass = classes[0]

            if(!firstClass) continue;

            dom.push(<tr>
                <td rowSpan={classes.length}>{this.getActionIcon(student.action)} {student.get('name')}</td>
                <td rowSpan={classes.length}>{student.get('username')}</td>
                <td rowSpan={classes.length}>{student.get('password')}</td>
                <td>{firstClass.getName()}</td>
                {this.getStudentOptions(student.getID() , firstClass.uid , classes.length , "option-1" , student.action)}
            </tr>);

            for(var jdx = 1; jdx < classes.length; jdx++ ){
                var _class = student.get('classes')[jdx];
                if(this.state.tabIndex != 0)
                {
                    dom.push(<tr><td colSpan={2} className="p-10">{_class.getName()}</td></tr>)

                }
                else
                {
                    dom.push(<tr><td className="p-10">{_class.getName()}</td>{this.getStudentOptions(students[idx].getID() , _class.uid , classes.length  , "option-2" , student.action)}</tr>)
                }
            }
        }

        return dom;
    }

    renderAllStudents(students){

        let data = this.state.search ? this.state.searchResults : this.getData();
        return  <Table condensed responsive bordered>
                    <thead>
                        <tr>
                            <th><FormattedMessage id={ 'ui-14' } defaultMessage={ 'Name' }/></th>
                            <th><FormattedMessage id={ 'ui-22' } defaultMessage={ 'Username' }/></th>
                            <th><FormattedMessage id={ 'ui-23' } defaultMessage={ 'Password' }/></th>
                            <th colSpan={4}><FormattedMessage id={ 'ui-830' } defaultMessage={ 'Classes' }/></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderTableBody(data)}
                    </tbody>
                </Table>
    }

    constructTempStudent(uid , name , username , password , classes , action){
        var obj = new Student(uid, name , username , password ,  classes);
            obj.action = action
        return obj
    }

    getData(){

        if(this.state.tabIndex == 0 ) return this.state.students;
        else
        {
            var classList      = [];
            var newClassObject = {uid:0 , name:this.props.data.name || "....."};


            for(var idx = 0; idx < this.state.studentsToAdd.length; idx++)
            {
                var student = StudentsStore.getStudentByID(this.state.studentsToAdd[idx]);

                classList.push(this.constructTempStudent(student.get('uid'), student.get('name') , student.get('username') , student.get('password') , student.classesRaw.concat(newClassObject) , 'add'));
            }

            for(var key in this.state.moveFrom)
            {
                if(!this.state.moveFrom.hasOwnProperty(key)) continue;
                var student = StudentsStore.getStudentByID(key);
                var newClassList = [];

                for(var classIdx = 0 ; classIdx < student.classesRaw.length; classIdx++)
                {
                    if(this.state.moveFrom[key].classes.indexOf(student.classesRaw[classIdx].uid)) continue;
                    newClassList.push(student.classesRaw[classIdx]);
                }

                classList.push(this.constructTempStudent(student.get('uid'), student.get('name') , student.get('username') , student.get('password') , newClassList.concat(newClassObject) , 'move'));
            }

            return  classList.concat(this.state.newStudnts);
        }
    }

    handelAddStudentsInput(e){
        var students = [];
        var studentNames = e.target.value.split(/\r?\n/);

        for (var idx = 0; idx < studentNames.length; idx++) {
            var name = studentNames[idx];
            if (name.length > 0){
                students.push(studentNames[idx]);
            }
        }

        autosize(this.newStudentsTextArea);
        this.studentNames = students;
        this.search.value = students[students.length -1] || "";
    }

    handelAddStudents(){
        this.search.value = "";
        this.newStudentsTextArea.value = "";
        this.setState({search:false , searchResults:[] , newStudnts:this.convertUserInputToStudents(this.props.data.newStudents.concat(this.studentNames))});
        this.studentNames = [];
    }

    handelUserSearch(searchTerm){

        if(searchTerm.length <= 0)
        {
            this.setState({
                search:false,
                searchResults:[],
                index:0
            })
        }

        var searchObjects = this.getData();

        var results = [];

        for(var idx = 0; idx < searchObjects.length; idx++)
        {
            var student = searchObjects[idx];
            var searchString = student.get('name')+'|';

            for(var jdx = 0; jdx < student.classesRaw.length; jdx++)
            {
                searchString +=  '|'+student.classesRaw.name;
            }

            if(fuzzysearch(searchTerm , searchString)){
                results.push(student);
            }

        }

        this.setState({
            search:true,
            searchResults:results,
            index:0
        })
    }

    handelKeyDown(){
        clearTimeout(this.state.typingTimer);
    }

    handelKeyUp(){
        clearTimeout(this.state.typingTimer);

        this.setState({
            typingTimer:setTimeout(function(){ this.handelUserSearch(this.search.value) }.bind(this), 500)
        });
    }

    handelTextBlur()
    {
        this.search.value = "";
        this.setState({
            search:false,
            searchResults:[],
            index:0
        })
    }

    render(){

        this.setSumbitPropsFromState();
        return <div>
                    <Row className="row p-b-10 m-b-20">
                        <Col sm={12}>
                            <FGFormGroup helpBlock={<HelpBlock><FormattedMessage id={ 'ui-455' } defaultMessage={ 'Paste ot type your class list here one name per line' }/></HelpBlock>}>
                                <ControlLabel className="fg"><FormattedMessage id={ 'ui-903' } defaultMessage={ 'Create New Students' }/></ControlLabel>
                                <FormControl onBlur={this.handelTextBlur.bind(this)}  onKeyUp={this.handelKeyUp.bind(this)} onKeyDown={this.handelKeyDown.bind(this)} inputRef={(input) => this.newStudentsTextArea = input} componentClass="textarea" onChange={this.handelAddStudentsInput.bind(this)}/>
                            </FGFormGroup>
                        </Col>
                        <Col sm={12}>
                            <button onClick={this.handelAddStudents.bind(this)} className="btn btn-block btn-primary" ><FormattedMessage id={ 'ui-904' } defaultMessage={ 'Add New Students' }/></button>
                        </Col>
                    </Row>
                    <Row>
                        <Nav className="tab-nav p-0" activeKey={this.state.tabIndex} onSelect={this.handelTabSelect}>
                            <NavItem eventKey={0} >
                                <FormattedMessage id="ui-870" defaultMessage="Existing Students"/>
                            </NavItem>
                            <NavItem eventKey={1} >
                                <FormattedMessage id="ui-500" defaultMessage="Selected students"/>
                            </NavItem>
                        </Nav>
                    </Row>
                    <Row>
                        <FormGroup className="m-0">
                            <div className="input-group">
                                <span className="input-group-addon"><i className="zmdi zmdi-search"></i></span>
                                <div className="table-search-field">
                                    <input type="text" onKeyUp={this.handelKeyUp.bind(this)} onKeyDown={this.handelKeyDown.bind(this)} ref={(input) => this.search = input} className="table-search-field form-control" placeholder=""/>
                                </div>
                            </div>
                        </FormGroup>
                        {this.renderAllStudents()}
                    </Row>
                    <Row>
                        <Pagination
                            prev
                            next
                            first
                            last
                            items={this.state.search ? Math.ceil(this.state.searchResults.length/this.state.limit) : Math.ceil(this.getAlUnassignedStudentsLength()/this.state.limit)}
                            maxButtons={5}
                            activePage={this.state.index+1}
                            onSelect={this.handleSelect} />
                    </Row>
               </div>;
    }
}



export default {
    name: <FormattedMessage id={ 'ui-905' } defaultMessage={ 'Add Students & Review' }/>,
    title:null,
    onSubmit: function (done){

        if(this.props.data.newStudents.length > 0 || this.props.data.moveStudents.length > 0 || this.props.data.addStudents.length > 0)
        {
            done();
        }
        else
        {
            done(new Error(InternationalizationStore.getTranslation('ui-342' ,'You need to enter students to continue' )));
        }
    },
    component: ReviewStudents
}


// WEBPACK FOOTER //
// ./src/components/wizard/create-class-steps/review-students.js